import { render, staticRenderFns } from "./personalCard.vue?vue&type=template&id=5cb30654&scoped=true"
import script from "./personalCard.vue?vue&type=script&lang=js"
export * from "./personalCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5cb30654",
  null
  
)

export default component.exports